enum youfirstEnvEnum {
	CAMPUS = 'campus',
	RESIDENCE = 'residence',
	ACQUISITION = 'acquisition',
	ACQUISITION_RESIDENCE = 'acquisition_residence',
	ACQUISITION_RESIDENCE_ATTACHED = 'acquisition_residence_attached'
}

export default youfirstEnvEnum
